export default {
  button: {
    cancel: 'cancel',
    confirm: 'Confirm',
    add: 'Add',
    settings: 'Settings',
    back: 'Back',
    next: 'Next',
    edit: 'Edit',
    finish: 'Finish',
    preview: 'Preview',
    deselect: 'Deselect',
    select: 'Select',
    validate: 'Validate',
    ecran: '+ Screen',
    search: 'Search',
    exit: 'Exit',
  },
  tabs: {
    screens: 'Screens list',
    dispositions: 'Dispositions list',
    models: 'Models',
    recents: 'Recent',
    images: 'Images',
    videos: 'Videos',
    empty: 'Empty slide',
  },
  panels: {
    selectedScreen: ' Selected screen',
    addNewScreen: 'Add new screen',
    addNewSegment: 'Add new segment',
    newSegment: 'New segment',
    deleteScreen: 'Delete screen',
    duplicateScreen: 'Duplicate screen',
    duplicateSegment: 'Duplicate segment',
    screenSettings: 'Screen settings',
    editScreen: 'Edit screen',
    edit_title: 'Edit title',
    title: 'Title',
    duration: 'Duration',
    infos: {
      title: 'Informations',
      name_segment: ' Name of segment:',
      duration_segment: 'Duration of segment:',
      duration_total: 'Total duration:',
      name_template: 'Name of template:',
      duration_template: 'Duration of template:',
      size_template: 'Size of template:',
      name_screen: 'Name of screen:',
      duration_screen: 'Duration of screen:',
    },
  },
  modal: {
    reclamation_placeholder: 'Describe the problem.',
    reclamation_title: 'Send feedback',
    about: 'About',
    error: 'Message Erorr',
    okText: 'Continue',
    cancelText: 'Cancel',
    verifDuration: 'The duration of the screens is greater than the duration of the template',

    delete: {
      title: 'Are you sure to delete it?',
      confirm_title: 'Deleted',
      confirm_msg: 'Deleted successfully .',
      cancel_title: 'Cancel',
      cancel_msg: 'Delete canceled',
      btn_confirm: 'Delete!',
      btn_cancel: 'Cancel',
    },
    edit: {
      title: 'Edit the title of this screen',
      error_msg: 'Enter a name',
      btn_confirm: 'Edit',
      btn_cancel: 'Cancel',
    },
    setting: {
      title: 'Setting',
      layers: 'Layers',
      effects: 'Effects',
      opacity: 'Opacity',
      delay: 'Delay(ms)',
      animation: {
        title: 'Animation',
        grow: 'Grow',
        shrink: 'Shrink',
        'fade-in': 'Fade in',
        'fade-out': 'Fade in',
        'fade-up': 'Fade up',
        'fade-down': 'Fade down',
        'fade-left': 'Fade left',
        'fade-right': 'Fade right',
        'zoom-in': 'Zoom in',
        'zoom-out': 'Zoom out',
        without_animation: 'Without animation',
        without_transition: 'none',
        convex: 'convex',
        strike: 'Strike',
        'reveal-text': 'Reveal text',
      },
    },
    add_generic: {
      title: 'Select a generic video ',
      subtitle: 'You should add a generic video to save the project',
      btn_add: 'Add',
      start: 'start',
      end: 'finish',
    },
  },
  disposition: {
    segment: 'Segment',
    disposition: 'Disposition',
    add: 'Add current disposition',
    name: 'Disposition name',
    empty: 'Empty slide',
  },
  screens: {
    select: 'Select screen',
    empty: 'Empty screen',
    screen: 'Screen',
  },
  template: {
    add_name: 'Add an name to your template:',
    name: 'Template name',
    save_template: 'save Template',
    save_as_template: 'Save as a copie of Template',
    save_as_copie: 'Save as a copie',
    save_as_video: 'Publish ',
    save_and_exit: '  Save and exit',
    new_template: 'New program',
    new_ligne: 'New line',
    reclamation: 'Reclamation',
  },
  labels: {
    duration: 'Duration',
    direction: 'Transition direction',
    transition: 'Transition type',
    add_model: 'add a new model',
    add_models: 'add model',
    models: 'Models',
    images: 'Images',
    videos: 'Videos',
    recent: 'Recents',
    title: 'Title',
    ligne: 'Line',
    edit_template_name: 'Please change the name of your template:',
    add_template_name: 'Give a name to your Template:',
    Foreground: 'Foreground',
    advance_more: 'Advance more',
    background: 'Background',
    Recede_less: 'Recede less',
    press: 'Press ',
    exit_fullScreen: 'to exit full screen',
    no_models: 'No models',
    no_images: 'No Images',
    no_videos: 'No Videos',
    'text-add': 'Add',
  },
  placeholder: {
    search: 'Search..',
    title: 'Title...',
    describe_problem: 'Describe the problem',
    template_title: 'Template title',
  },
  titles: {
    send_comment: 'Send comments',
    title_transition: 'List of transitions between slides',
  },
  tooltips: {
    'sw-visibility': 'Show Borders',
    preview: 'Preview',
    fullscreen: 'Fullscreen',
    'preview-screens': 'Preview screens',
    'export-template': 'Export',
    undo: 'Undo',
    redo: 'Redo',
    'gjs-open-import-webpage': 'Import',
    'canvas-clear': 'Clear canvas',
    'open-sm': 'Style Manager',
    'open-layers': 'Layers',
    'open-blocks': 'Blocks',
    save: 'Save',
    'save-template': 'Save',
    move: 'Move',
    duplicate: 'Duplicate',
    delete: 'Delete',
    setting: 'Setting',
    edit: 'Edit',
  },
  blocks: {
    column1: 'One column',
    column2: 'Two columns',
    column3: 'Three columns',
    'column3-7': 'Two columns 3/7',
    custom_column2: 'two columns',
    filet: 'Separator',
    text: 'Text',
    link: 'Link',
    image: 'Image',
    image_media: 'Image',
    video: 'Video',
    map: 'Map',
    'h-navbar': 'Navbar',
    countdown: 'Countdown',
    form: 'Form',
    input: 'Input',
    textarea: 'Textarea',
    select: 'Select',
    button: 'Button',
    label: 'Label',
    checkbox: 'Checkbox',
    radio: 'Radiobox',
    'link-block': 'Link block',
    quote: 'Quote',
    select_video: 'Select Video',
    select_image: 'Select image',
    drop_files: 'Drop files here or click to upload',
    select_screen: 'selected one or more screens',
    select_new: 'selected a media',
    add_generic_debut: 'Generic Video Start ',
    add_generic_fin: 'Generic Video End ',
    add_generic_intro: 'Introduction Video ',
    preview_screens: 'Preview screens',
    'text-basic': 'Text Basic',
    'lory-slider': 'Lory Slider',
    playlist: 'Playlist',
    Weather: 'Weather',
    Clock: 'Clock',
    facebook_widget: 'Facebook',
    linkedin_widget: 'LinkedIn',
    rss_widget: 'RSS',
    ticker: 'Ticker',
    web_widget: 'Web',
    webrtc_widget: 'WebRtc',
    player: 'Player',
    video_mp4: 'Player mp4',
    live: 'Live',
    generic_begin: 'Generic Begin',
    generic_end: 'Generic End',
    'social-icons-twitter': 'Twitter',
    Basic: 'Basic',
    Extra: 'Extra',
    Forms: 'Forms',
    Widget: 'Widget',
    Pattern: 'Motifs',
    Media: 'Media',
    column: 'Column',
    Tides: 'Tides',
    endText: 'Expired',
    labelDays: 'Days',
    labelHours: 'Hours',
    labelMinutes: 'Minutes',
    labelSeconds: 'Seconds',
    dateHeure: 'Date and Time',
    Text: 'Text',
    Areas: 'Areas',
    Medias: 'Medias',
    Social: 'Social networks',
    Disposition: 'Disposition',
    Dimension: 'Dimension',
    Spacing: 'Spacing',
    Decoration: 'Decoration',
    Background: 'Background',
    Border: 'Border',
    Responsive: 'Responsive',
    params: 'Advanced settings',
    social_media: 'Medias',
    'social-media': 'Select medias',
    'image-media': 'Select image',
    'select_image-media': 'Select image',
    select_pattern: 'Select pattern',
    'custom-title': 'Title block ',
    'custom-sharing': 'Sharing block ',
    'custom-credit': 'Credit block',
    pattern: 'Pattern',
    'custom-countdown': 'countdown',
  },
  'display-tides-plugin': {
    tides: 'Tides',
    title: 'Title',
    lat: 'Latitude',
    lng: 'Longitude',
    start: 'Start',
    end: 'End',
    airTemperature: 'Air temperature',
    humidity: 'Humidity',
    cloudCover: 'Cloud cover',
    currentDirection: 'Current Direction',
    currentSpeed: 'Current speed',
    precipitation: 'Precipitation',
    swellDirection: 'Swell direction',
    swellHeight: 'Swell height',
    swellPeriod: 'Swell period',
    waterTemperature: 'Water temperature',
    waveDirection: 'Wave Direction',
    waveHeight: 'Wave height',
    wavePeriod: 'Wave period',
    windWaveDirection: 'Direction of wind waves',
    windWaveHeight: 'Height of wind waves',
    windWavePeriod: 'Period of wind waves',
    seaLevel: 'Sea level',
    windDirection: 'Wind direction',
    windSpeed: 'Wind speed',
    gust: 'Gust',
  },
  'display-weather-plugin': {
    city: 'City',
    title: 'Temperature on',
    current: 'Current',
  },
  'display-clock-plugin': {
    title_clock: 'Date and hour',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
  'display-dateHeure-plugin': {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
  'display-player-plugin': {
    select_new: 'select a media',
    placeholder: 'Search video..',
  },
  message: {
    pageNotFound: 'Nothing Found',
    copy: 'copy',
  },
  'display-ticker-plugin': {
    loading: 'Loading...',
    save: 'Save',
    modalTitle: 'Enter your text line by line',
  },
  'display-countdown-plugin': {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    model: 'Model',
    startfrom: 'Target date',
    hourfrom: 'Target time (HH:MM)',
    showStartDate: 'Show start date',
    source: 'choose format',
    startText: 'Start text',
    endText: 'Expired',
    endPosition: 'After',
    startPosition: 'Before',
    countdown1: 'CountDown 1',
    countdown2: 'CountDown 2',
    countdown3: 'CountDown 3',
    labelDays: 'Days',
    labelHours: 'Hours',
    labelMinutes: 'Minutes',
    labelSeconds: 'Seconds',
    formJours: 'Days',
    formHeures: 'Hours',
    formMinutes: 'Minutes',
    formSecondes: 'Seconds',
    textBefore: 'Before',
    textAfter: 'After',
  },
  empreinte:
    ' Aujourd’hui, empreinte.com est le leader français indépendant. Sa clientèle, composée de grands\n' +
    'comptes est pérenne (100% de réabonnement). Depuis 2015 empreinte a connu une croissance de\n' +
    '+60%. En 2017, la société reçoit une aide BPI innovation de 100 K€ et réalise 1 M€ CA avec 575 K€\n' +
    'de fonds propres. En 2018 elle obtient la note H3 de la Banque de France.\n',
  past_css: 'Paste here your HTML/CSS and click Import',
  biblioSegment: {
    allSegments: 'All segments',
    'placeholder-title': 'New segment',
    noSearch: 'No segment corresponds to your search',
    trySearch: 'Try using other search terms and options',
    editSegment: 'Editing a segment',
    textEdit:
      'Modify the parameters of your chosen segment according to the criteria presented below',
    addSegment: 'Adding a segment',
    textAdd: 'Add the parameters of your chosen segment according to the criteria presented below',
    textDelete: 'The selected segment is deleted',
    title: 'Title:',
    theme: 'Theme:',
    selectTheme: 'Select one or more themes.',
    selectOneTheme: 'Select one theme.',
    description: 'Description:',
    addDescription: 'Adding a description ...',
    author: 'Author :',
    selectAuthor: 'Select an author.',
    Keyword: 'Keyword:',
    addkeyword: 'Adding a keyword',
    addTitle: 'Adding a Title',
    noResult: 'The list is empty ..',
    noOption: 'No items found.',
  },
  addProgram: {
    textAddLine: 'Add a title and line number',
    textAdd: 'Add a title',
    add: 'Create a new program',
  },
  sizeCanvas: 'Suitable for the screen',
  module: {
    timeline: {
      title: 'Selected',
    },
    segment: {
      title: 'Add segment',
    },
    slide: {
      title: 'Add slide',
    },
    generic: {
      title: 'Generic add',
      textAdd: 'Select a ',
      success_add: 'Generic added',
    },
  },
  exitSave: {
    exitEditor: 'Exit the editor',
    exitPage: 'Are you sure you want to leave the page?',
  },
  styleManager: {
    color: 'Color',
    background: 'Background',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en_US.js